import Vue from 'vue'
import VueRouter from 'vue-router'
import index from '../views/web/index'


Vue.use(VueRouter)

const routes = [
  

    {
      path: '/',
      name: 'index',
      component: () => import(/* webpackChunkName: "news" */ '../views/web/index.vue')
    },
    {
      path: '/news',
      name: 'news',
      component: () => import(/* webpackChunkName: "news" */ '../views/web/news.vue')
    },

    {
      path: '/product',
      name: 'product',
      component: () => import(/* webpackChunkName: "product" */ '../views/web/product.vue')
    },
    {
      path: '/information',
      name: 'information',
      component: () => import(/* webpackChunkName: "information" */ '../views/web/information.vue')
    },

    {
      path: '/ours',
      name: 'ours',
      component: () => import(/* webpackChunkName: "ours" */ '../views/web/ours.vue')
    },

    {
      path: '*',
      redirect: '/'
    }

  
]

const router = new VueRouter({
  routes,
  scrollBehavior: (to, from, savedPosition) => {
    return { x: 0, y: 0 }
  },
})

export default router
